import { useCallback, useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { MyInfoState } from '@/recoil/atom';
import { isProd } from '@/constant'; // 핀의 프로젝트 경로에 맞게 수정하세요

// 1. 운영에서 로그를 볼 수 있는 '선택받은 자들'의 사번 리스트
const WHITELIST_EMPLOYEE_NUMBERS = [
  'X202407003', // 운영 portal_test
];

export const useDebugLogger = () => {
  const myInfo = useAtomValue(MyInfoState);

  // 2. 로그 노출 여부 판단 로직
  const canShowLog = useMemo(() => {
    // (1) 운영 환경이 아니라면 무조건 보여줌
    if (!isProd) return true;

    // (2) 운영 환경이면 화이트리스트에 내 사번이 있는지 확인
    const myEmployeeNumber = myInfo?.employeeNumber;
    if (!myEmployeeNumber) return false;

    return WHITELIST_EMPLOYEE_NUMBERS.includes(myEmployeeNumber);
  }, [myInfo]);

  // 3. console.log 래퍼 함수
  const log = useCallback(
    (...args: any[]) => {
      if (!canShowLog) return;
      // [Debug] 태그를 붙여서 일반 로그와 구분하기 쉽게 만듦
      console.log('%c[Debug]', 'color: #00bcd4; font-weight: bold;', ...args);
    },
    [canShowLog],
  );

  const warn = useCallback(
    (...args: any[]) => {
      if (!canShowLog) return;
      console.warn('[Debug]', ...args);
    },
    [canShowLog],
  );

  const error = useCallback(
    (...args: any[]) => {
      if (!canShowLog) return;
      console.error('[Debug]', ...args);
    },
    [canShowLog],
  );

  return { log, warn, error, canShowLog };
};
